export default __webpack_public_path__ + "static/handing-endoscope-13ac960bda1db283127acde3067d0bd0.jpg";